import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "content-panel",
  style: {"max-width":"1000px"}
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-icon" }
const _hoisted_4 = { class: "panel-body" }
const _hoisted_5 = { class: "instruction-icon" }
const _hoisted_6 = { class: "employees-table-card billing-data-card" }
const _hoisted_7 = { class: "employees-table-header" }
const _hoisted_8 = { class: "header-subtitle" }
const _hoisted_9 = { class: "employees-count" }
const _hoisted_10 = {
  key: 0,
  class: "billing-loading"
}
const _hoisted_11 = { class: "billing-tab-panels" }
const _hoisted_12 = { class: "summary-panel" }
const _hoisted_13 = { class: "summary-grid" }
const _hoisted_14 = { class: "summary-card" }
const _hoisted_15 = { class: "summary-icon" }
const _hoisted_16 = { class: "summary-content" }
const _hoisted_17 = { class: "summary-value" }
const _hoisted_18 = { class: "summary-card" }
const _hoisted_19 = { class: "summary-icon" }
const _hoisted_20 = { class: "summary-content" }
const _hoisted_21 = { class: "summary-value" }
const _hoisted_22 = { class: "summary-card" }
const _hoisted_23 = { class: "summary-icon" }
const _hoisted_24 = { class: "summary-content" }
const _hoisted_25 = { class: "summary-value" }
const _hoisted_26 = { class: "employees-table-wrapper" }
const _hoisted_27 = { class: "employees-table-wrapper" }
const _hoisted_28 = {
  key: 1,
  class: "billing-empty"
}
const _hoisted_29 = { class: "status-card-text" }
const _hoisted_30 = { class: "status-card-actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "confirm-dialog-header" }
const _hoisted_35 = { class: "confirm-dialog-footer" }
const _hoisted_36 = { class: "confirm-dialog-header" }
const _hoisted_37 = { class: "confirm-dialog-footer" }
const _hoisted_38 = { class: "confirm-dialog-header warning" }
const _hoisted_39 = { class: "confirm-dialog-footer" }
const _hoisted_40 = { class: "upload-modal-header" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "upload-modal-body" }
const _hoisted_43 = { class: "upload-notice" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "dropzone-icon-wrapper" }
const _hoisted_47 = {
  key: 0,
  class: "files-section"
}
const _hoisted_48 = { class: "files-section-header" }
const _hoisted_49 = { class: "files-count" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "files-list" }
const _hoisted_52 = { class: "file-card-icon" }
const _hoisted_53 = { class: "file-card-info" }
const _hoisted_54 = { class: "file-card-name" }
const _hoisted_55 = { class: "file-card-size" }
const _hoisted_56 = ["onClick", "disabled"]
const _hoisted_57 = {
  key: 0,
  class: "upload-warning"
}
const _hoisted_58 = { class: "upload-modal-footer" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface BillingRow {
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StepTwo',
  props: {
    uploadedFilesCount: {},
    billingData: {},
    billingDetailData: {},
    isLoading: { type: Boolean },
    activeYear: {},
    activeMonth: {},
    isConfirmed: { type: Boolean },
    isConfirming: { type: Boolean }
  },
  emits: ["uploaded", "confirm", "release"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const uploadedFilesCount = computed(() => props.uploadedFilesCount || 0);
const hasUploaded = computed(() => uploadedFilesCount.value >= 2);
const billingData = computed(() => props.billingData || []);
const billingDetailData = computed(() => props.billingDetailData || []);
const isLoading = computed(() => !!props.isLoading);
const isConfirmed = computed(() => !!props.isConfirmed);
const isConfirming = computed(() => !!props.isConfirming);
const hasBillingData = computed(() => billingData.value.length > 0);
const hasBillingDetailData = computed(() => billingDetailData.value.length > 0);
const hasAnyData = computed(() => hasBillingData.value || hasBillingDetailData.value);
const totalDataCount = computed(() => billingData.value.length + billingDetailData.value.length);
const periodLabel = computed(() => {
  const year = props.activeYear || new Date().getFullYear();
  const month = String(props.activeMonth || new Date().getMonth() + 1).padStart(2, '0');
  return `${year}.${month}`;
});

// 요약 데이터 계산
const summaryData = computed(() => {
  const uniquePatients = new Set<string>();
  const uniqueCaregivers = new Set<string>();
  let totalSugaMoney = 0;

  // 청구내역상세에서 수급자와 수가 합계 계산
  billingDetailData.value.forEach(row => {
    if (row.lebd_patient_code) {
      uniquePatients.add(row.lebd_patient_code);
    }
    const sugaMoney = Number(row.lebd_suga_money);
    if (!Number.isNaN(sugaMoney)) {
      totalSugaMoney += sugaMoney;
    }
  });

  // 청구내역에서 요양보호사 수 계산
  billingData.value.forEach(row => {
    if (row.leb_caregiver_name) {
      uniqueCaregivers.add(row.leb_caregiver_name);
    }
  });

  return {
    totalPatients: uniquePatients.size,
    totalCaregivers: uniqueCaregivers.size,
    totalSugaMoney
  };
});

const activeTab = ref<'summary' | 'billing' | 'detail'>('summary');
const showReuploadConfirm = ref(false);
const showConfirmDialog = ref(false);
const showReleaseDialog = ref(false);
const showBulkUploadDialog = ref(false);
const bulkFiles = ref<File[]>([]);
const bulkFileInput = ref<HTMLInputElement | null>(null);
const isBulkUploading = ref(false);
const isDragging = ref(false);
const isReuploadMode = ref(false);

watch(
  () => [billingData.value.length, billingDetailData.value.length],
  () => {
    if (hasAnyData.value) {
      activeTab.value = 'summary';
    }
  },
  { immediate: true }
);

const confirmReupload = () => {
  if (isConfirmed.value) {
    store.commit('showSnackbar', {
      text: '확정 상태에서는 재업로드할 수 없어요. 해제 후 다시 시도해주세요.',
      color: 'warning'
    });
    return;
  }
  showReuploadConfirm.value = true;
};

const proceedReupload = () => {
  showReuploadConfirm.value = false;
  openBulkUpload('reupload');
};

const handleConfirm = () => {
  showConfirmDialog.value = true;
};

const proceedConfirm = () => {
  showConfirmDialog.value = false;
  emit('confirm');
};

const handleRelease = () => {
  showReleaseDialog.value = true;
};

const proceedRelease = () => {
  showReleaseDialog.value = false;
  emit('release');
};

const openInitialUpload = () => {
  openBulkUpload('initial');
};

const openBulkUpload = (mode: 'initial' | 'reupload' = 'initial') => {
  isReuploadMode.value = mode === 'reupload';
  showBulkUploadDialog.value = true;
};

const closeBulkUpload = () => {
  if (isBulkUploading.value) return;
  showBulkUploadDialog.value = false;
  bulkFiles.value = [];
  isDragging.value = false;
  isReuploadMode.value = false;
};

const triggerFileInput = () => {
  bulkFileInput.value?.click();
};

const handleDropzoneClick = () => {
  if (isBulkUploading.value) return;
  triggerFileInput();
};

const handleDragOver = () => {
  if (isBulkUploading.value) return;
  isDragging.value = true;
};

const handleDragLeave = () => {
  if (isBulkUploading.value) return;
  isDragging.value = false;
};

const handleDrop = (event: DragEvent) => {
  if (isBulkUploading.value) return;
  isDragging.value = false;
  const files = event.dataTransfer?.files;
  if (files) {
    addFiles(Array.from(files));
  }
};

const handleBulkFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = target.files;
  if (files) {
    addFiles(Array.from(files));
  }
  target.value = '';
};

const addFiles = (newFiles: File[]) => {
  const excelFiles = newFiles.filter(file => {
    const ext = file.name.split('.').pop()?.toLowerCase();
    return ext === 'xls' || ext === 'xlsx';
  });
  
  if (excelFiles.length < newFiles.length) {
    store.commit('showSnackbar', {
      text: '엑셀 파일만 업로드 가능해요',
      color: 'warning'
    });
  }
  
  excelFiles.forEach(file => {
    const isDuplicate = bulkFiles.value.some(f => f.name === file.name && f.size === file.size);
    if (!isDuplicate) {
      bulkFiles.value.push(file);
    }
  });
};

const removeFile = (index: number) => {
  bulkFiles.value.splice(index, 1);
};

const clearAllFiles = () => {
  bulkFiles.value = [];
};

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

const executeBulkUpload = async () => {
  if (bulkFiles.value.length === 0) return;
  
  // 연월 검증을 위한 변수
  const expectedYear = props.activeYear;
  const expectedMonth = props.activeMonth;
  const expectedYM = `${expectedYear}${String(expectedMonth).padStart(2, '0')}`;
  
  isBulkUploading.value = true;
  const user = store.state.user;
  
  let successCount = 0;
  let failCount = 0;
  const errorMessages: string[] = [];
  
  for (const file of bulkFiles.value) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('year', expectedYear.toString());
      formData.append('institutionCode', user.m_sisul_code);
      
      const response = await axios.post('/api/files/bulk-upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
      });
      
      if (response.data.success) {
        const fileYM = response.data.fileYearMonth;
        
        // 파일 내 연월과 선택된 연월이 다른 경우
        if (fileYM && fileYM !== expectedYM) {
          const fileYear = fileYM.substring(0, 4);
          const fileMonth = fileYM.substring(4, 6);
          errorMessages.push(
            `${file.name}: 파일 내 연월(${fileYear}년 ${parseInt(fileMonth)}월)이 선택된 연월(${expectedYear}년 ${expectedMonth}월)과 다릅니다.`
          );
          failCount++;
        } else {
          successCount++;
        }
      } else {
        failCount++;
        errorMessages.push(`${file.name}: ${response.data.message || '업로드 실패'}`);
      }
    } catch (error: any) {
      failCount++;
      const errorMsg = error.response?.data?.message || error.message || '알 수 없는 오류';
      errorMessages.push(`${file.name}: ${errorMsg}`);
      console.error('업로드 오류:', error);
    }
  }
  
  isBulkUploading.value = false;
  
  // 재업로드 모드일 경우
  if (isReuploadMode.value) {
    if (successCount > 0) {
      store.commit('showSnackbar', {
        text: `✅ ${successCount}개 파일이 재업로드되었어요!`,
        color: 'success'
      });
      emit('uploaded', successCount);
      closeBulkUpload();
    } else {
      // 에러 메시지 표시
      const errorText = errorMessages.length > 0 
        ? errorMessages.join('\n') 
        : '파일 업로드에 실패했어요';
      store.commit('showSnackbar', {
        text: errorText,
        color: 'error'
      });
    }
  } else {
    // 최초 업로드 모드일 경우
    if (successCount >= 2) {
      store.commit('showSnackbar', {
        text: `✅ ${successCount}개 파일이 업로드되었어요!`,
        color: 'success'
      });
      emit('uploaded', successCount);
      closeBulkUpload();
    } else if (successCount > 0) {
      store.commit('showSnackbar', {
        text: `${successCount}개 파일이 업로드되었지만, 청구내역, 청구내역상세 파일 2개가 모두 필요해요`,
        color: 'warning'
      });
    } else {
      // 에러 메시지 표시
      const errorText = errorMessages.length > 0 
        ? errorMessages.join('\n') 
        : '파일 업로드에 실패했어요';
      store.commit('showSnackbar', {
        text: errorText,
        color: 'error'
      });
    }
  }
};

const formatDate = (value?: string | number | null) => {
  if (!value) return '-';
  const str = value.toString();
  if (str.includes('-')) return str;
  if (str.length === 8) {
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
  }
  return str;
};

const formatTime = (value?: string | number | null) => {
  if (!value) return '-';
  const str = value.toString().replace(/[^0-9]/g, '');
  if (str.length === 4) {
    return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
  }
  return value.toString();
};

const formatYesNo = (value?: string | null) => {
  if (!value) return '-';
  return value === 'Y' ? '예' : value === 'N' ? '아니오' : value;
};

const formatCurrency = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') return '-';
  const num = Number(value);
  if (Number.isNaN(num)) return value.toString();
  return `${num.toLocaleString()}원`;
};



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32",
          color: "#1e3a8a"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("mdi-file-document-multiple", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "panel-title-section" }, [
        _createElementVNode("h2", { class: "panel-title" }, "파일 업로드하기")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["instruction-card", { 'move-bottom': hasUploaded.value }])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-monitor-arrow-down", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"instruction-content\" data-v-a3eec458><h4 data-v-a3eec458>파일 다운로드 안내</h4><ol data-v-a3eec458><li data-v-a3eec458>장기요양정보시스템 접속 후 우측 상단 <strong data-v-a3eec458>기타</strong> &gt; <strong data-v-a3eec458>엑셀 다운로드</strong>를 클릭합니다.</li><li data-v-a3eec458><strong data-v-a3eec458>청구내역</strong>, <strong data-v-a3eec458>청구내역상세</strong> 탭에서 각각 <strong data-v-a3eec458>엑셀 다운로드</strong> 버튼을 눌러 2개 파일을 저장합니다.</li><li data-v-a3eec458>브라우저 저장 창에서 <strong data-v-a3eec458>Ctrl + Shift + S</strong>로 파일을 저장해 주세요.</li></ol><p class=\"instruction-hint\" data-v-a3eec458>청구내역, 청구내역상세 파일 2개를 모두 준비해야 다음 단계로 이동할 수 있습니다.</p></div>", 1))
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "업로드된 데이터", -1)),
            _createElementVNode("p", _hoisted_8, _toDisplayString(periodLabel.value) + " 기준", 1)
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(totalDataCount.value  || 0) + " 건 ", 1)
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "#1e3a8a",
                size: "32"
              }),
              _cache[13] || (_cache[13] = _createElementVNode("span", null, "데이터를 불러오는 중입니다...", -1))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (hasAnyData.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_tabs, {
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                      class: "billing-tabs",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tab, { value: "summary" }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("요약데이터", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "billing" }, {
                          default: _withCtx(() => [
                            _createTextVNode("청구내역 (" + _toDisplayString(billingData.value.length) + ")", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "detail" }, {
                          default: _withCtx(() => [
                            _createTextVNode("청구내역상세 (" + _toDisplayString(billingDetailData.value.length) + ")", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-account-group", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-label" }, "총 수급자 수", -1)),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(summaryData.value.totalPatients) + "명", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                color: "#059669"
                              }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("mdi-account-heart", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "summary-label" }, "총 요양보호사 수", -1)),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(summaryData.value.totalCaregivers) + "명", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                color: "#7c3aed"
                              }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("mdi-file-document", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "summary-label" }, "총 수가", -1)),
                              _createElementVNode("div", _hoisted_25, _toDisplayString(formatCurrency(summaryData.value.totalSugaMoney)), 1)
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, activeTab.value === 'summary']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_26, [
                        _createElementVNode("table", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "일자"),
                              _createElementVNode("th", null, "수급자명"),
                              _createElementVNode("th", null, "수급자 코드"),
                              _createElementVNode("th", null, "요양보호사명"),
                              _createElementVNode("th", null, "생년월일"),
                              _createElementVNode("th", null, "요양보호사번호"),
                              _createElementVNode("th", null, "구분"),
                              _createElementVNode("th", null, "가족 여부"),
                              _createElementVNode("th", null, "가족 관계"),
                              _createElementVNode("th", null, "근무 시작"),
                              _createElementVNode("th", null, "근무 종료"),
                              _createElementVNode("th", null, "서비스 구분"),
                              _createElementVNode("th", null, "수가 코드"),
                              _createElementVNode("th", null, "수가명")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingData.value, (row, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.leb_idx || index
                              }, [
                                _createElementVNode("td", null, _toDisplayString(formatDate(row.leb_date)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_patient_name), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_patient_code), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_caregiver_name), 1),
                                _createElementVNode("td", null, _toDisplayString(formatDate(row.leb_caregiver_birth)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_caregiver_code || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_caregiver_gubun || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(formatYesNo(row.leb_familly_rel)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_familly_who || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(formatTime(row.leb_start_time)), 1),
                                _createElementVNode("td", null, _toDisplayString(formatTime(row.leb_end_time)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_service_gubun || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_suga_code || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.leb_suga_name || '-'), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 512), [
                        [_vShow, activeTab.value === 'billing']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_27, [
                        _createElementVNode("table", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "처리상태"),
                              _createElementVNode("th", null, "수급자명"),
                              _createElementVNode("th", null, "수급자 코드"),
                              _createElementVNode("th", null, "일자"),
                              _createElementVNode("th", null, "시작시간"),
                              _createElementVNode("th", null, "종료시간"),
                              _createElementVNode("th", null, "요양보호사명"),
                              _createElementVNode("th", null, "수가코드"),
                              _createElementVNode("th", null, "수가명"),
                              _createElementVNode("th", null, "수가"),
                              _createElementVNode("th", null, "감산점수"),
                              _createElementVNode("th", null, "감산비율")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingDetailData.value, (row, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.lebd_idx || index
                              }, [
                                _createElementVNode("td", null, _toDisplayString(row.lebd_pay_status || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_patient_name), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_patient_code), 1),
                                _createElementVNode("td", null, _toDisplayString(formatDate(row.lebd_date)), 1),
                                _createElementVNode("td", null, _toDisplayString(formatTime(row.lebd_start_time)), 1),
                                _createElementVNode("td", null, _toDisplayString(formatTime(row.lebd_end_time)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_caregiver_name), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_suga_code || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_suga_name || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(formatCurrency(row.lebd_suga_money)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_minus_point || '-'), 1),
                                _createElementVNode("td", null, _toDisplayString(row.lebd_minus_rate || '-'), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 512), [
                        [_vShow, activeTab.value === 'detail']
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_v_icon, {
                      size: "32",
                      color: "#9ca3af"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-file-document-alert", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[24] || (_cache[24] = _createElementVNode("p", null, "아직 업로드된 데이터가 없습니다.", -1))
                  ]))
            ], 64))
      ]),
      (hasAnyData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["status-card", isConfirmed.value ? 'info' : 'success'])
          }, [
            _createVNode(_component_v_icon, {
              color: isConfirmed.value ? '#10b981' : '#00C73C',
              size: "24"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isConfirmed.value ? 'mdi-lock-check' : 'mdi-check-circle'), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h4", null, _toDisplayString(isConfirmed.value ? '데이터 확정됨' : '데이터 업로드 완료'), 1),
              _createElementVNode("p", null, _toDisplayString(isConfirmed.value
              ? '확정 상태예요. 해제 후에만 데이터를 수정하거나 재업로드할 수 있습니다.'
              : hasUploaded.value 
                ? '2개 파일이 모두 업로드되었습니다. 확정을 눌러 다음 단계로 진행하세요.'
                : `${uploadedFilesCount.value}개 파일만 업로드됨. 청구내역, 청구내역상세 파일 2개가 모두 필요합니다.`), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                class: "btn-outline",
                onClick: confirmReupload,
                disabled: isConfirmed.value || isConfirming.value
              }, " 재업로드 ", 8, _hoisted_31),
              (isConfirmed.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-outline",
                    onClick: handleRelease,
                    disabled: isConfirming.value
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "#047857",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _cache[25] || (_cache[25] = _createTextVNode(" 확정 해제 ", -1))
                  ], 8, _hoisted_32))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-outline confirm-emphasis",
                    onClick: handleConfirm,
                    disabled: !hasUploaded.value || isConfirming.value
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "#047857",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _cache[26] || (_cache[26] = _createTextVNode(" 데이터 확정 ", -1))
                  ], 8, _hoisted_33))
            ])
          ], 2))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-primary-large",
            onClick: openInitialUpload
          }, [
            _createVNode(_component_v_icon, { class: "btn-icon" }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("mdi-cloud-upload", -1)
              ]))]),
              _: 1
            }),
            _cache[28] || (_cache[28] = _createElementVNode("span", null, "파일 업로드하기", -1))
          ]))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showReuploadConfirm.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showReuploadConfirm).value = $event)),
      "max-width": "440px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#f59e0b"
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("mdi-alert-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[30] || (_cache[30] = _createElementVNode("h3", null, "파일 재업로드", -1))
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
              _createElementVNode("p", null, "기존에 업로드된 데이터는 삭제됩니다."),
              _createElementVNode("p", null, "정말 재업로드하시겠습니까?")
            ], -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showReuploadConfirm.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "btn-confirm",
                onClick: proceedReupload
              }, "재업로드")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showConfirmDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showConfirmDialog).value = $event)),
      "max-width": "440px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#10b981"
              }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                  _createTextVNode("mdi-lock-check", -1)
                ]))]),
                _: 1
              }),
              _cache[33] || (_cache[33] = _createElementVNode("h3", null, "데이터 확정", -1))
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
              _createElementVNode("p", null, "데이터를 확정하시겠습니까?"),
              _createElementVNode("p", null, "확정 후에는 데이터를 수정하거나 재업로드할 수 없습니다.")
            ], -1)),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "btn-confirm",
                onClick: proceedConfirm
              }, "확정")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showReleaseDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showReleaseDialog).value = $event)),
      "max-width": "440px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#f59e0b"
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                  _createTextVNode("mdi-alert-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[36] || (_cache[36] = _createElementVNode("h3", null, "확정 해제", -1))
            ]),
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
              _createElementVNode("p", null, "데이터 확정을 해제하시겠습니까?"),
              _createElementVNode("p", null, "해제 후에는 데이터를 다시 수정하거나 재업로드할 수 있습니다.")
            ], -1)),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showReleaseDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "btn-confirm warning",
                onClick: proceedRelease
              }, "해제")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showBulkUploadDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showBulkUploadDialog).value = $event)),
      "max-width": "560px",
      persistent: isBulkUploading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "upload-modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _cache[39] || (_cache[39] = _createElementVNode("h2", null, "파일 업로드", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: closeBulkUpload,
                disabled: isBulkUploading.value
              }, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_41)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#1e40af"
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("mdi-information", -1)
                  ]))]),
                  _: 1
                }),
                (isReuploadMode.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "수정이 필요한 파일만 업로드하세요"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_45, [...(_cache[41] || (_cache[41] = [
                      _createElementVNode("strong", null, "청구내역", -1),
                      _createTextVNode(", ", -1),
                      _createElementVNode("strong", null, "청구내역상세", -1),
                      _createTextVNode(" 파일 2개를 모두 업로드하세요", -1)
                    ]))]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["dropzone-area", { 'is-active': isDragging.value, 'is-disabled': isBulkUploading.value }]),
                onDrop: _withModifiers(handleDrop, ["prevent"]),
                onDragover: _withModifiers(handleDragOver, ["prevent"]),
                onDragleave: _withModifiers(handleDragLeave, ["prevent"]),
                onClick: handleDropzoneClick
              }, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_v_icon, {
                    size: "56",
                    color: isDragging.value ? '#1e3a8a' : '#94a3b8'
                  }, {
                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                      _createTextVNode("mdi-cloud-upload", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "dropzone-text" }, "파일을 드래그하거나 클릭하세요", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("p", { class: "dropzone-hint" }, "엑셀 파일 (xls, xlsx)", -1))
              ], 34),
              _createElementVNode("input", {
                ref_key: "bulkFileInput",
                ref: bulkFileInput,
                type: "file",
                multiple: "",
                accept: ".xls,.xlsx",
                style: {"display":"none"},
                onChange: handleBulkFileSelect
              }, null, 544),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (bulkFiles.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, "선택된 파일 " + _toDisplayString(bulkFiles.value.length) + "개", 1),
                          _createElementVNode("button", {
                            class: "clear-btn",
                            onClick: clearAllFiles,
                            disabled: isBulkUploading.value
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                _createTextVNode("mdi-delete-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[46] || (_cache[46] = _createTextVNode(" 전체 삭제 ", -1))
                          ], 8, _hoisted_50)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_TransitionGroup, { name: "list" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkFiles.value, (file, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: file.name + index,
                                  class: "file-card"
                                }, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_component_v_icon, {
                                      color: "#10b981",
                                      size: "28"
                                    }, {
                                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                        _createTextVNode("mdi-file-excel", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("span", _hoisted_54, _toDisplayString(file.name), 1),
                                    _createElementVNode("span", _hoisted_55, _toDisplayString(formatFileSize(file.size)), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    class: "file-card-delete",
                                    onClick: ($event: any) => (removeFile(index)),
                                    disabled: isBulkUploading.value
                                  }, [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                      default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                        _createTextVNode("mdi-close", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_56)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (!isReuploadMode.value && bulkFiles.value.length > 0 && bulkFiles.value.length < 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          color: "#f59e0b"
                        }, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode("mdi-alert", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[50] || (_cache[50] = _createElementVNode("span", null, "청구내역, 청구내역상세 파일 2개를 모두 선택해주세요", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: closeBulkUpload,
                disabled: isBulkUploading.value
              }, " 취소 ", 8, _hoisted_59),
              _createElementVNode("button", {
                class: "btn-upload",
                onClick: executeBulkUpload,
                disabled: (isReuploadMode.value ? bulkFiles.value.length === 0 : bulkFiles.value.length < 2) || isBulkUploading.value
              }, [
                (isBulkUploading.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "18",
                      width: "2",
                      color: "white",
                      class: "mr-2"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(isBulkUploading.value ? '업로드 중...' : `${bulkFiles.value.length}개 파일 업로드`), 1)
              ], 8, _hoisted_60)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"])
  ]))
}
}

})